import { Typography, makeStyles, withStyles } from "@material-ui/core";

import { TheCycleverseTheme } from "src/theme";

const widthDefault = 450;
const widthWider = 600;
const widthThinner = 300;

// ------------------------------------------------------
const paragraphStyles = makeStyles((theme: TheCycleverseTheme) => ({
  paragraph: {
    marginBottom: theme.spacing(2),
  },
}));

export const Paragraph = (props) => {
  const classes = paragraphStyles();
  return (
    <Typography variant="body1" className={classes.paragraph}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const claimStyles = makeStyles((theme: TheCycleverseTheme) => ({
  claim: {
    fontSize: "x-large",
    maxWidth: widthThinner,
    marginBottom: theme.spacing(3),
    textAlign: "center",
    margin: "auto",
  },
}));

export const Claim = (props) => {
  const classes = claimStyles();
  return (
    <Typography variant="h3" className={classes.claim}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const subHeadlineStyles = makeStyles((theme: TheCycleverseTheme) => ({
  subHeadline: {
    fontSize: "x-large",
    marginBottom: theme.spacing(2),
  },
}));

export const SubHeadline = (props) => {
  const classes = subHeadlineStyles();
  return (
    <Typography variant="h3" className={classes.subHeadline}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const subsubHeadlineStyles = makeStyles((theme: TheCycleverseTheme) => ({
  subsubHeadline: {
    fontSize: "large",
    fontWeight: 600,
  },
}));

export const SubSubHeadline = (props) => {
  const classes = subsubHeadlineStyles();
  return (
    <Typography variant="h4" className={classes.subsubHeadline}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const shortStyles = makeStyles((theme: TheCycleverseTheme) => ({
  short: {
    maxWidth: widthWider,
    fontSize: "large",
    marginBottom: theme.spacing(6),
    display: "inline-block",
  },
}));

export const Short = (props) => {
  const classes = shortStyles();
  return (
    <Typography variant="body1" className={classes.short}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const shortMainStyles = makeStyles((theme: TheCycleverseTheme) => ({
  short: {
    maxWidth: widthWider,
    fontSize: 14,
    marginBottom: 46,
    marginTop: 14,
    display: "inline-block",
  },
}));

export const ShortMain = (props) => {
  const classes = shortMainStyles();
  return (
    <Typography component="div" variant="body1" className={classes.short}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const headlineStyles = makeStyles((theme: TheCycleverseTheme) => ({
  headline: {
    marginBottom: theme.spacing(4),
  },
}));

export const Headline = (props) => {
  const classes = headlineStyles();
  return (
    <Typography variant="h3" className={classes.headline}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const headlineMainStyles = makeStyles((theme: TheCycleverseTheme) => ({
  headline: {
    marginBottom: 0,
    marginTop: 20,
    fontWeight: 300,
    fontSize: "2em",
    maxWidth: widthDefault,
    display: "inline-block",
  },
}));

export const HeadlineMain = (props) => {
  const classes = headlineMainStyles();
  return (
    <Typography variant="h1" className={classes.headline}>
      {props.children}
    </Typography>
  );
};

// ------------------------------------------------------
const headlineTeaserStyles = makeStyles((theme: TheCycleverseTheme) => ({
  headlineTeaser: {
    color: theme.saleColor,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    maxWidth: widthDefault,
    textAlign: "center",
    margin: "auto",
  },
}));

export const HeadlineTeaser = (props) => {
  const classes = headlineTeaserStyles();
  return (
    <Typography variant="body1" className={classes.headlineTeaser}>
      {props.children}
    </Typography>
  );
};
